import { render } from "./grid-footer.vue?vue&type=template&id=3fba2f22&scoped=true"
import script from "./grid-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-footer.vue?vue&type=script&setup=true&lang=js"

import "./grid-footer.vue?vue&type=style&index=0&id=3fba2f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fba2f22"],['__file',"src/components/grid-footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fba2f22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fba2f22', __exports__)) {
    api.reload('3fba2f22', __exports__)
  }
  
  module.hot.accept("./grid-footer.vue?vue&type=template&id=3fba2f22&scoped=true", () => {
    api.rerender('3fba2f22', render)
  })

}


export default __exports__